import { ItemList } from "@/shared/components/ui/ItemList";
import type { Appointment } from "../types/appointmentTypes";
import { AppointmentListCard } from "./AppointmentListCard";

interface AppointmentsListProps {
  appointments: Appointment[];
  onAppointmentClick: (appointment: Appointment) => void;
  isLoading?: boolean;
  error?: Error | null;
}

export function AppointmentsList({ appointments, onAppointmentClick, isLoading, error }: AppointmentsListProps) {
  const sorted = [...appointments].sort((a, b) => (a.startAt?.getTime() ?? Infinity) - (b.startAt?.getTime() ?? Infinity));
  return (
    <ItemList
      items={sorted}
      isLoading={isLoading}
      error={error}
      emptyState={{ message: "No appointments for this day." }}
      renderItem={(appointment) => <AppointmentListCard appointment={appointment} onClick={onAppointmentClick} />}
    />
  );
}
